import React from 'react';
import {Route} from 'react-router-dom';

import {EditPage} from './editPage';

/** Renders routes to edit a meeting for use as children on a react-router Switch. */
export const editRoutes = <Route key="edit" path="/edit/:bookingToken" element={<EditPage />} />;
